import React from 'react';
import Lottie from 'react-lottie';

const Loader = () => (
    <div className="relative h-fit w-full flex justify-center items-center top-1/2 -translate-y-1/2 z-[80]">
        <Lottie
            options={{
                loop: true,
                autoplay: true,
                animationData: require('../img/animation/SCAPE-LOGO SPINNING.json'),
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
            }}
            height={150}
            width={150}
        />
    </div>
);

export default Loader;
